import React from 'react'
import { useParams } from 'react-router-dom'
import { useLazyMeQuery } from '../../store/kopiliot-api/base-api'

const RessourceDetails: React.FC = () => {
  const { id: ressourceID } = useParams() as { id: string }
  const [triggerGetMe] = useLazyMeQuery()
  const [error, setError] = React.useState<string | null>(null)

  // verrou très strict
  const isTriggered = React.useRef(false)

  React.useEffect(() => {
    if (!ressourceID || isTriggered.current) return
    isTriggered.current = true

    const downloadFile = async () => {
      try {
        //const me = await triggerGetMe(null).unwrap()
        //if (!me) throw new Error('Utilisateur non authentifié')

        const token = localStorage.getItem('access_token')
        if (!token) throw new Error('Token manquant')

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/v1/resources/${ressourceID}/download`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )

        if (!response.ok) throw new Error('Erreur lors du téléchargement')

        let filename = 'unknown'
        const disposition = response.headers.get('Content-Disposition')

        if (disposition) {
          // Cas RFC 5987 : filename*=utf-8''some%20file.pdf
          const filenameStarMatch = disposition.match(
            /filename\*\s*=\s*([^']*)''([^;]+)/i
          )
          if (filenameStarMatch) {
            try {
              filename = decodeURIComponent(filenameStarMatch[2])
            } catch (_) {
              filename = filenameStarMatch[2]
            }
          } else {
            // Cas simple : filename="some file.pdf"
            const filenameMatch = disposition.match(
              /filename\s*=\s*"?([^"]+)"?/i
            )
            if (filenameMatch?.[1]) {
              filename = filenameMatch[1]
            }
          }
        }
        const blob = await response.blob()
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        a.click()
        URL.revokeObjectURL(url)
      } catch (err) {
        setError((err as Error).message)
      }
    }

    downloadFile()
  }, [ressourceID, triggerGetMe])

  return (
    <div id="dwl-zone">
      {error ? (
        <p className="text-red-600">Erreur : {error}</p>
      ) : (
        <p>Votre fichier est en cours de téléchargement...</p>
      )}
    </div>
  )
}

export default RessourceDetails
